<template>
  <div class="content">
    <gmap></gmap>
  </div>
</template>
<script>
import gmap from '@/components/Gmap.vue'
export default {
  components: {
    gmap
  },
  data () {
    return {}
  }
}
</script>
<style lang='less' scoped>
.content {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>